import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { PlusLg, Trash3 } from 'react-bootstrap-icons';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import PhoneWidget from '../../../../Generic/PhoneWidget';
import { useLanguage } from '../../../../../../API/Context/LanguageContext';
import VocabProMenu from '../../../../../../ConfigFiles/multilingual/VocabProMenu';

export interface ContactPoint {
  number: string;
  extension: string | null;
  is_whatsapp: boolean;
  is_telegram: boolean;
  label: string;
}

interface ContactPointsSectionProps {
  localId: string;
  contactPoints: ContactPoint[];
  onAddContact: () => void;
  onChangeContact: (idx: number, field: keyof ContactPoint, value: any) => void;
  onRemoveContact: (idx: number) => void;
}

export const ContactPointsSection: React.FC<ContactPointsSectionProps> = ({
  localId,
  contactPoints,
  onAddContact,
  onChangeContact,
  onRemoveContact,
}) => {
  const { t } = useLanguage();

  return (
    <div className="border-top pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="m-0 fw-bold">{t(VocabProMenu, 'contact_points')}</h6>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onAddContact}
          className="d-flex align-items-center gap-1"
        >
          <PlusLg size={12} />
          <span>{t(VocabProMenu, 'add_contact')}</span>
        </Button>
      </div>

      {contactPoints.map((cp, cpIdx) => (
        <Row key={cpIdx} className="g-2 mb-2 align-items-center bg-white p-2 rounded border">
          <Col md={4}>
            <PhoneWidget
              value={cp.number}
              onChange={(val) => onChangeContact(cpIdx, 'number', val || '')}
            />
          </Col>
          <Col md={2}>
            <Form.Control
              type="text"
              placeholder={t(VocabProMenu, 'extension')}
              value={cp.extension || ''}
              onChange={(e) => onChangeContact(cpIdx, 'extension', e.target.value || null)}
            />
          </Col>
          <Col md={2}>
            <Form.Control
              type="text"
              placeholder={t(VocabProMenu, 'label')}
              value={cp.label}
              onChange={(e) => onChangeContact(cpIdx, 'label', e.target.value)}
            />
          </Col>
          <Col md={3} className="d-flex align-items-center justify-content-around">
            <Form.Check
              type="switch"
              id={`wa-toggle-${localId}-${cpIdx}`}
              label={<FaWhatsapp className="text-success ms-1" />}
              checked={cp.is_whatsapp}
              onChange={(e) => onChangeContact(cpIdx, 'is_whatsapp', e.target.checked)}
            />
            <Form.Check
              type="switch"
              id={`tg-toggle-${localId}-${cpIdx}`}
              label={<FaTelegramPlane className="text-primary ms-1" />}
              checked={cp.is_telegram}
              onChange={(e) => onChangeContact(cpIdx, 'is_telegram', e.target.checked)}
            />
          </Col>
          <Col md={1} className="text-end">
            <Button
              variant="link"
              className="text-danger p-0"
              onClick={() => onRemoveContact(cpIdx)}
            >
              <Trash3 size={14} />
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
};
